import FormCheckBoxControls from "../../../forms/fieldsControl/FormCheckBoxControls";

export const CheckboxRenderer = (col, columnEvents = {}) => (rowData) => {
    const handler = columnEvents?.CHECKBOX;
    const value = rowData?.[col.field];

    return (
        <>
            {/* 
               * Now, This Tooltip is commented. Because, Right now, We dont' need it.
               * If you want to use it, you can uncomment it. and below the TargetId also uncomment.
            */}
            {/* <Tooltip label={rowData[col.field] ? "Active" : "In-active"}
                targetId={rowData.isActive ? 'active' : 'inactive'} /> */}
            <FormCheckBoxControls
                id={rowData.id}
                name={col.field}
                dataField={col.field}
                value={!!value}
                onChange={(dataField, value) =>
                    handler?.(dataField, value, rowData)
                }
            // targetId={rowData.isActive ? 'active' : 'inactive'}
            />
        </>
    );
};